// Recent activity feed — scope-aware via /api/home/widget/recent-activity.
import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Clock } from "lucide-react";

function timeAgo(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return `${Math.round(diff)}s ago`;
    if (diff < 3600) return `${Math.round(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.round(diff / 3600)}h ago`;
    return `${Math.round(diff / 86400)}d ago`;
}

const ACTION_LABEL = {
    upload_file: "uploaded file", create_dashboard: "created dashboard",
    update_dashboard: "edited dashboard", delete_dashboard: "deleted dashboard",
    rebuild_auto_dashboard: "regenerated dashboard",
    regenerate_template_dashboard: "regenerated template",
    create_connector: "added connector", sync_connector: "synced connector",
    invite_user: "invited user", login: "signed in",
    create_release_note: "added release note",
};

export default function RecentActivityWidget() {
    const [items, setItems] = useState(null);
    useEffect(() => {
        api.get("/home/widget/recent-activity")
           .then((r) => setItems(r.data || [])).catch(() => setItems([]));
    }, []);
    return (
        <div className="border border-border rounded-sm bg-card p-4 h-full" data-testid="home-widget-recent-activity">
            <div className="flex items-center gap-1.5 mb-3">
                <Clock className="h-3.5 w-3.5 text-muted-foreground" />
                <span className="eyebrow text-[10px]">Recent activity</span>
            </div>
            {items === null && <div className="text-xs text-muted-foreground">Loading…</div>}
            {items && items.length === 0 && (
                <div className="text-xs text-muted-foreground py-4 text-center">No activity yet.</div>
            )}
            {items && items.length > 0 && (
                <ul className="space-y-1.5 max-h-[320px] overflow-y-auto scrollbar-thin pr-1">
                    {items.map((it, i) => {
                        const action = ACTION_LABEL[it.action] || (it.action || "").replace(/_/g, " ");
                        return (
                            <li key={i} className="text-[12px] leading-snug border-l-2 border-border pl-2.5 py-0.5"
                                data-testid={`home-activity-${i}`}>
                                <span className="font-medium">{it.user_name || it.user_email?.split("@")[0] || "someone"}</span>
                                <span className="text-muted-foreground"> {action}</span>
                                {it.target_name && <span className="font-mono text-[11px]"> · {it.target_name}</span>}
                                <span className="text-muted-foreground/70 text-[10px] font-mono ml-1">{timeAgo(it.created_at)}</span>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
}
